import { render, staticRenderFns } from "./addLevel2TagModal.vue?vue&type=template&id=525ecb53&scoped=true"
import script from "./addLevel2TagModal.vue?vue&type=script&lang=js"
export * from "./addLevel2TagModal.vue?vue&type=script&lang=js"
import style0 from "./addLevel2TagModal.vue?vue&type=style&index=0&id=525ecb53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ecb53",
  null
  
)

export default component.exports